import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import dynamic from 'next/dynamic';

import useMobile from '@hooks/useMobile';

import type { StrapiBiasType } from '@local-types/data';

import Logos from '@components/Logos';
import Spinner from '@components/Spinner';
import Header from '@components/Header';
import MobileView from '@components/_biases/MobileView';
import Quote from '@components/Quote/Quote';
import MagicMenu from '@components/MagicMenu';
import HeaderLInks from '@components/HeaderLInks';

import styles from './UXCoreLayout.module.scss';

const CoreViewLayout = dynamic(() => import('@layouts/CoreViewLayout'), {
  ssr: false,
});

const Search = dynamic(() => import('@components/_biases/Search'), {
  ssr: false,
});

interface UXCoreLayoutProps {
  strapiBiases: StrapiBiasType[];
  isOpen?: boolean;
  biasSelected?: boolean;
  description?: string;
}

const UXCoreLayout: FC<UXCoreLayoutProps> = ({
  strapiBiases,
  biasSelected,
}) => {
  const router = useRouter();
  const isMobile = useMobile();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isMobileFullHeight, setIsMobileFullHeight] = useState(false);

  const routes = [{ name: 'Bullying', path: '/', logo: 'bullying' }];
  useEffect(() => {
    setIsLoaded(true);
  }, [router.events]);

  if (!isLoaded) {
    return <Spinner visible={true} />;
  }

  return (
    <>
      <Header isMobile={isMobile} routes={routes} />
      <section
        className={cn(styles.body, {
          [styles.openedModal]: biasSelected,
          [styles.mobileView]: isMobile,
          [styles.fullHeight]: isMobileFullHeight,
        })}
      >
        {isMobile && <HeaderLInks routes={routes} />}
        {isMobile && <MagicMenu />}
        {isMobile && <Quote />}
        {isMobile && <Logos className={styles.Logos} />}
        {isMobile ? (
          <>
            <Search biases={strapiBiases} />
            <MobileView
              biases={strapiBiases}
              page={'bullying-defence'}
              setIsMobileFullHeight={setIsMobileFullHeight}
            />
          </>
        ) : (
          <>
            <Search biases={strapiBiases} />
            <CoreViewLayout styles={styles} biases={strapiBiases} />
            <Logos className={styles.Logos} />
          </>
        )}
      </section>
    </>
  );
};

export default UXCoreLayout;
